import { Directive, AfterViewInit, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCalendarMask]'
})
export class CalendarMaskDirective implements AfterViewInit {
  @Input() mask: string = '99/99/9999';
  @Input() dropSpecialCharacters: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // p-calendar renders an internal input
    const inputEl: HTMLInputElement | null = this.el.nativeElement.querySelector('input');

    if (!inputEl) {
      console.warn('CalendarMaskDirective: <input> not found inside p-calendar.');
      return;
    }

    // Add the ngx-mask attributes dynamically
    this.renderer.setAttribute(inputEl, 'mask', this.mask);
    this.renderer.setAttribute(inputEl, 'dropSpecialCharacters', String(this.dropSpecialCharacters));

    // Optionally trigger Angular change detection if needed
    inputEl.dispatchEvent(new Event('input'));
  }
}
